import { avatarColorClass } from '../lib/avatarColor'

function getInitials(name: string): string {
  const trimmed = name.trim()
  if (!trimmed) return '?'
  const [first, second] = trimmed.split(/\s+/)
  return ((first?.[0] ?? '') + (second?.[0] ?? '')).toUpperCase()
}

interface Props {
  name: string
  seed: string
  size?: 'sm' | 'md'
}

export function UserAvatar({ name, seed, size = 'md' }: Props) {
  const colorClass = avatarColorClass(seed)
  const sizeClass = size === 'sm' ? 'h-8 w-8 text-xs' : 'h-9 w-9 text-sm'

  return (
    <div className={`flex shrink-0 items-center justify-center rounded-full font-semibold ${sizeClass} ${colorClass}`}>
      {getInitials(name)}
    </div>
  )
}
